import { ShowerHead, Snowflake, ThermometerSnowflake, Flame, Wind, AlertTriangle } from 'lucide-react';

const ITEMS = [
  { icon: ShowerHead, color: '#00C8FF', name: 'Cold Shower', freq: 'Every morning', text: 'Aim for about 3 minutes as a simple daily cold-exposure habit.' },
  { icon: Snowflake, color: '#38BDF8', name: 'Cold Plunge', freq: '2× per week', text: 'At least twice per week as part of your recovery routine.' },
  { icon: ThermometerSnowflake, color: '#A78BFA', name: 'Cryotherapy', freq: '2× per week', text: 'Can replace or complement your cold plunge sessions.' },
  { icon: Flame, color: '#FF8A3D', name: 'Sauna', freq: '2× per week', text: 'At least twice per week to complement your recovery routine.' },
  { icon: Wind, color: '#65A30D', name: 'Breathing', freq: 'Daily', text: 'Breathing exercises to support relaxation and stress management.' },
];

export const RecoveryProtocol = () => (
  <div className="regen-card-elevated p-5 lg:p-6 space-y-4" data-testid="recovery-protocol">
    <div>
      <div className="label-mini text-[var(--c-green-ink)]">YourReGen Recovery Protocol</div>
      <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
        Recovery is an essential pillar of the YourReGen Method. Managing inflammation, supporting recovery and reducing unnecessary
        physiological stress support your fat-loss, performance and longevity goals.
      </p>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2.5">
      {ITEMS.map(({ icon: Icon, color, name, freq, text }) => (
        <div key={name} className="rounded-xl border border-[var(--c-hair)] bg-[var(--c-film)] p-3" data-testid={`protocol-${name.toLowerCase().replace(/\s+/g, '-')}`}>
          <div className="flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg grid place-items-center shrink-0" style={{ background: `${color}1A`, color }}><Icon className="w-4 h-4" /></span>
            <div className="min-w-0">
              <div className="font-semibold text-sm leading-tight">{name}</div>
              <div className="text-[11px] font-semibold text-foreground/70 leading-tight">{freq}</div>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-1.5 leading-snug">{text}</p>
        </div>
      ))}
    </div>
    <p className="text-xs text-muted-foreground leading-relaxed">
      More recovery activity may provide additional benefits, depending on your needs and training schedule. Recovery supports
      training consistency and long-term health. Follow your recovery provider's guidance on session length.
    </p>
    <div className="flex items-start gap-2 text-xs rounded-xl border border-[#FFB800]/40 bg-[#FFB800]/10 p-3" data-testid="protocol-cold-warning">
      <AlertTriangle className="w-4 h-4 text-[#FFB800] shrink-0 mt-0.5" />
      <span><b>Training tip:</b> avoid cold plunge within 6 hours after a strength session when muscle growth is a priority — immediate cold-water immersion may interfere with some muscle adaptation.</span>
    </div>
  </div>
);
